<div class="configuration">
  <app-module-title moduleName="Configuration"></app-module-title>

  <div class="action-tabs-container">
    <div class="custom-tabs">
      <div
        class="custom-tab"
        [ngClass]="{ active: activeTab === 'country' }"
        (click)="navigateToTab('country')"
      >
        Country
      </div>
      <div
        class="custom-tab"
        [ngClass]="{ active: activeTab === 'type-of-change' }"
        (click)="navigateToTab('type-of-change')"
      >
        Type Of Change
      </div>
      <div
        class="custom-tab"
        [ngClass]="{ active: activeTab === 'product-family' }"
        (click)="navigateToTab('product-family')"
      >
        Product Family
      </div>
    </div>
  </div>

  <div class="tab-content-container">
    <router-outlet></router-outlet>
  </div>
</div>
